__turbopack_context__.v({
  "className": "zkVJ7a_className",
  "variable": "zkVJ7a_variable",
});
